<div class="content-profile account-profile">
    <div class="animate">
        <section class="account-profile__grid">

            <!-- Sync / RGPD notification -->
            <div class="account-note" *ngIf="isOpenedNotification && isSynchronized">
                <i class="account-note__icon icon icon-info"></i>

                <span class="account-note__text">
                    {{ 'words.account.sync-data-advertising' | translate }}
                </span>

                <msc-button class="account-note__cta msc-button--primary msc-button--tiny" palette="secondary"
                    icon="icon-message-circle" *ngIf="canDoRGPDRequest"
                    (click)="requestUpdate(company.experience.contact)">
                    {{ 'words.account.rgpd-request' | translate }}
                </msc-button>
            </div>

            <!-- ===== Header card ===== -->
            <div class="account-card">
                <div class="account-profile__header">
                    <div class="account-profile__identity">
                        <!-- Avatar (siempre editable) -->
                        <div id="academic-field-photo" class="account-profile__avatar" [class.account-anchor-target--active]="activeAcademicField === 'photo'">
                            <div class="account-profile__avatar-ring">
                                <div class="avatar-editable">
                                    <ng-container *ngIf="!loadings.avatar">
                                        <img *ngIf="hasUploadedPicture" [src]="profileEdit.picture + '?size=128'" [alt]="profileEdit?.name"
                                            class="w-full h-full rounded-full object-cover">
                                        <svg *ngIf="!hasUploadedPicture" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                            fill="currentColor" class="account-profile-avatar__icon">
                                            <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 2c-4.418 0-8 2.239-8 5v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1c0-2.761-3.582-5-8-5z"></path>
                                        </svg>
                                    </ng-container>

                                    <msc-common-spinner *ngIf="loadings.avatar"></msc-common-spinner>
                                </div>
                            </div>

                            <!-- Botón eliminar foto (fuera del ring para no recortarse y quedar por encima) -->
                            <a class="account-profile__avatar-remove"
                                *ngIf="(profileEdit?.mediaId || profile.mediaId) && !loadings.avatar && editEnabled"
                                (click)="deletePicture()">
                                <i class="icon icon-close-1"></i>
                            </a>

                            <button type="button" class="account-profile__avatar-badge" *ngIf="editEnabled"
                                (click)="uploadPicture()">
                                <i class="icon icon-camera"></i>
                            </button>

                            <input #upload class="display-none" type="file"
                                accept="image/png,image/jpeg,image/jpg,image/gif" fileUpload [fileUrl]="'media'"
                                (fileStatus)="updatePicture($event)">
                        </div>

                        <!-- Upload hint -->
                        <div>
                            <div class="account-profile__upload" *ngIf="editEnabled" (click)="uploadPicture()">
                                <i class="hidden icon icon-image"></i>
                                <p>
                                    {{ 'words.upload' | translate }}
                                    <span>{{ 'words.upload-info.type' | translate }}</span>
                                    <span>{{ 'words.upload-info.size' | translate }}</span>
                                </p>
                            </div>
                            <p class="account-field__hint">
                                <i class="icon icon-student"></i>
                                {{ 'account.profile.appears-on-academic-profile' | translate }}
                            </p>
                        </div>

                        <!-- Divisor vertical -->
                        <div class="hidden md:block w-px self-stretch bg-gray-200"></div>

                        <!-- Email / last connection (sin nombre) -->
                        <div class="account-profile__meta">
                            <p class="text-base font-semibold text-gray-700">{{ profile.firstname }} {{ profile.lastname }}</p>
                            <p class="account-profile__email">{{ profile.email }}</p>

                            <span class="account-profile__status" *ngIf="profile.lastConnection">
                                <span class="account-profile__status-dot"></span>
                                {{ 'words.last-connection' | translate }} : {{ profile.lastConnection | timeAgo | lowercase }}
                            </span>
                        </div>
                    </div>

                    <!-- Actions -->
                    <div class="account-profile__actions">
                        <msc-button class="msc-button--outline" [loading]="loadingDownload"
                            icon="icon-download-1" (click)="downloadHistoryWrapper()">
                            {{ 'words.download-history' | translate }}
                        </msc-button>
                    </div>
                </div>
            </div>

            <!-- ===== Academic profile completion banner ===== -->
            <div class="academic-banner" *ngIf="showAcademicBanner" [class.academic-banner--collapsed]="isAcademicBannerCollapsed">

                <!-- Fila colapsada: solo título + % + chevron para reabrir -->
                <button *ngIf="isAcademicBannerCollapsed" type="button" class="academic-banner__collapsed-row" (click)="toggleAcademicBanner()">
                    <span class="academic-banner__icon">🎓</span>
                    <span class="academic-banner__collapsed-text">
                        {{ 'account.profile.academic-banner-title-prefix' | translate }} {{ academicProfilePercent }}%
                    </span>
                    <i class="icon icon-chevron-down academic-banner__chevron"></i>
                </button>

                <ng-container *ngIf="!isAcademicBannerCollapsed">
                    <button type="button" class="academic-banner__close" (click)="toggleAcademicBanner()"
                        [attr.aria-label]="'account.profile.collapse-banner' | translate">
                        <i class="icon icon-chevron-up"></i>
                    </button>

                    <div class="academic-banner__header">
                        <span class="academic-banner__icon">🎓</span>
                        <p class="text-base font-semibold text-gray-700">
                            {{ 'account.profile.academic-banner-title-prefix' | translate }} {{ academicProfilePercent }}%
                        </p>
                    </div>

                    <p class="academic-banner__desc">{{ 'account.profile.academic-banner-desc' | translate }}</p>

                    <div class="academic-banner__chips">
                        <button *ngFor="let field of academicProfileFields" type="button" class="academic-banner__chip"
                            [class.academic-banner__chip--filled]="field.filled"
                            [class.academic-banner__chip--missing]="!field.filled"
                            (click)="focusAcademicField(field.key, field.filled)">
                            <i class="icon" [ngClass]="field.filled ? 'icon-checkmark-1' : 'icon-plus'"></i>
                            {{ field.labelKey | translate }}
                        </button>
                    </div>

                    <div class="academic-banner__footnote">
                        <p>
                            {{ 'account.profile.trayectoria-hint-prefix' | translate }}
                            <a class="text-gray-700" (click)="goToPublicProfile()">{{ 'account.profile.academic-profile' | translate }}</a>.
                        </p>
                    </div>
                </ng-container>
            </div>

            <!-- ===== General information card ===== -->
            <div class="account-card">
                <div class="account-card__title text-gray-700">
                    <span class="account-card__bar bg-gray-700"></span>
                    <h2 class="text-base font-semibold">{{ 'words.edit-profile' | translate }}</h2>
                </div>

                <div class="account-profile__fields">
                    <!-- Firstname -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.firstname' | translate }} <span class="text-red-500">*</span></p>
                        <input type="text" [(ngModel)]="profileEdit.firstname" [disabled]="isSynchronized || !editEnabled"
                            [placeholder]="'account.profile.placeholder.firstname' | translate"
                            class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                    </div>

                    <!-- Lastname -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.lastname' | translate }} <span class="text-red-500">*</span></p>
                        <input type="text" [(ngModel)]="profileEdit.lastname" [disabled]="isSynchronized || !editEnabled"
                            [placeholder]="'account.profile.placeholder.lastname' | translate"
                            class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                    </div>

                    <!-- Document id -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.document-id' | translate }}</p>
                        <input type="text" [(ngModel)]="profileEdit.documentId" [disabled]="isSynchronized || !editEnabled"
                            [placeholder]="'account.profile.placeholder.document-id' | translate"
                            class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                    </div>

                    <!-- Phone -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.phone' | translate }}</p>
                        <input type="text" [(ngModel)]="profileEdit.phoneNumber" [disabled]="isSynchronized || !editEnabled"
                            [placeholder]="'account.profile.placeholder.phone' | translate"
                            class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                    </div>

                    <!-- City + Country (combinados, se guardan juntos en profileEdit.city) -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'account.profile.city-country' | translate }}</p>
                        <div class="city-country-field rounded-md" [class.city-country-field--disabled]="isSynchronized || !editEnabled">
                            <input type="text" [(ngModel)]="cityInput" (ngModelChange)="onCityInputChange()"
                                [disabled]="isSynchronized || !editEnabled"
                                [placeholder]="'account.profile.placeholder.city-country' | translate"
                                class="city-country-field__input">
                            <div class="city-country-field__divider"></div>
                            <button type="button" class="city-country-field__country"
                                [disabled]="isSynchronized || !editEnabled"
                                (click)="toggleCountryDropdown($event)">
                                <span [class.city-country-field__country-placeholder]="!selectedCountry">
                                    {{ selectedCountry?.name || ('words.country' | translate) }}
                                </span>
                                <i class="icon icon-chevron-down"></i>
                            </button>
                            <div class="city-country-field__dropdown" *ngIf="countryDropdownOpen" (click)="$event.stopPropagation()">
                                <input type="text" [(ngModel)]="countrySearch"
                                    [placeholder]="'words.search' | translate"
                                    class="city-country-field__search">
                                <div class="city-country-field__options">
                                    <div *ngFor="let c of filteredCountries" class="city-country-field__option"
                                        (click)="selectCountry(c)">
                                        {{ c.name }}
                                    </div>
                                    <div *ngIf="!filteredCountries.length" class="city-country-field__option city-country-field__option--empty">
                                        {{ 'pc-admin.items.search.no-results' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Interface language (solo perfil ajeno) -->
                    <div class="account-field" *ngIf="profile.id !== me.id">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.interface-language' | translate }}</p>

                        <ng-container *ngIf="selectData.interfaceLanguages.length">
                            <msc-common-select [data]="selectData.interfaceLanguages">
                                <ng-template #buttonTemplate let-data="data">
                                    <button class="select-main">
                                        <ng-container *ngIf="data?.length">
                                            <img
                                                src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{data[0].value.code}}.svg">
                                            <span>{{ data[0].label }}</span>
                                        </ng-container>
                                    </button>
                                </ng-template>
                                <ng-template #optionTemplate let-datum="datum">
                                    <button class="select-option" (click)="onSelectOption(datum)">
                                        <img
                                            src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{datum.value.code}}.svg">
                                        <span>{{ datum.label }}</span>
                                    </button>
                                </ng-template>
                            </msc-common-select>
                        </ng-container>
                    </div>
                    <!-- Job -->
                    <div id="academic-field-headline" class="account-field" [class.account-anchor-target--active]="activeAcademicField === 'headline'">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">
                            {{ 'words.position' | translate }} / {{ 'words.career' | translate }}
                        </p>
                        <input type="text" [(ngModel)]="profileEdit.headline" [disabled]="isSynchronized || !editEnabled"
                            [placeholder]="'account.profile.placeholder.job' | translate"
                            class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                        <p class="account-field__hint">
                            <i class="icon icon-student"></i>
                            {{ 'account.profile.appears-on-academic-profile' | translate }}
                        </p>
                    </div>

                    <!-- Company name -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.company-name' | translate }} / {{ 'words.university' | translate }}</p>
                        <input type="text" [(ngModel)]="profileEdit.companyName" [disabled]="isSynchronized || !editEnabled"
                            [placeholder]="'account.profile.placeholder.company-name' | translate"
                            class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                    </div>

                    <!-- Department -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.department' | translate }} / {{ 'words.faculty' | translate }}</p>
                        <input type="text" [(ngModel)]="profileEdit.department" [disabled]="isSynchronized || !editEnabled"
                            [placeholder]="'account.profile.placeholder.department' | translate"
                            class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                    </div>

                    <!-- Función / roles -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">
                            {{ (me.id !== profile.id ? 'words.role-validity-period' : 'words.role') | translate }}
                        </p>

                        <div class="account-roles" *ngIf="me.id === profile.id">
                            <span class="account-roles__item" [tooltip]="'words.learn' | translate"
                                [ngClass]="{'account-roles__item--active': profile.companyRoles.companyLearner}">
                                <i class="icon icon-student"></i>
                            </span>
                            <span class="account-roles__item" [tooltip]="'words.create' | translate"
                                [ngClass]="{'account-roles__item--active': profile.companyRoles.companyAuthor}">
                                <i class="icon icon-color-palette"></i>
                            </span>
                            <span class="account-roles__item" [tooltip]="'words.coach' | translate"
                                [ngClass]="{'account-roles__item--active': profile.companyRoles.companyManager}">
                                <i class="icon icon-mentor"></i>
                            </span>
                            <span class="account-roles__item" [tooltip]="'words.organise' | translate"
                                [ngClass]="{'account-roles__item--active': profile.companyRoles.companyAdministrator}">
                                <i class="icon icon-calendar"></i>
                            </span>
                        </div>

                        <msc-button class="msc-button--outline" *ngIf="me.id !== profile.id"
                            (click)="manageAccess()">
                            {{ 'words.manage-roles' | translate }}
                        </msc-button>
                    </div>
                    <!-- External id -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">
                            {{ 'words.id' | translate }}
                            <ng-container *ngIf="profileEdit.companyUser.hasSSO">
                                <span [tooltip]="'profile.external-identifier.tooltip.hasSSO' | translate">
                                    <i class="icon icon-alert-circle"></i>
                                </span>
                            </ng-container>
                        </p>
                        <input type="text" [(ngModel)]="profileEdit.companyUser.externalId" [disabled]="isSynchronized || !editEnabled"
                            [placeholder]="'account.profile.placeholder.external-id' | translate"
                            class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                    </div>

                    <!-- Organization id -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.organization-id' | translate }}</p>
                        <input type="text" [(ngModel)]="profileEdit.organizationId" [disabled]="isSynchronized || !editEnabled"
                            autocomplete="off" name="organization-id" role="presentation"
                            [placeholder]="'account.profile.placeholder.organization-id' | translate"
                            class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                    </div>

                    <!-- Período de validez -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.validity-period' | translate }}</p>

                        <div class="account-license">
                            <div class="account-license__icon">
                                <i class="icon icon-shield"></i>
                            </div>
                            <div class="account-license__body">
                                <p class="account-license__title">{{ 'account.profile.license-active' | translate }}</p>
                                <p class="account-license__date">
                                    <span *ngIf="getTranslateDate()">{{ getTranslateDate() | translate }} {{
                                        profile.companyUser.accessStatus.accessStartAt ||
                                        profile.companyUser.subscriptionDate | date: 'd MMM YY' }}</span>
                                    <span *ngIf="profile.companyUser.accessStatus.accessEndAt"> - {{
                                        profile.companyUser.accessStatus.accessEndAt | date: 'd MMM YY' }}</span>
                                </p>
                            </div>
                        </div>


                    </div>
                </div>

                <!-- Biografía (dentro de Editar perfil) -->
                <div id="academic-field-biography" class="account-bio-anchor" [class.account-anchor-target--active]="activeAcademicField === 'biography'">
                    <div class="flex items-center justify-between my-2">
                        <h2 class="text-base font-semibold text-gray-800">{{ 'words.biography' | translate }} <span class="text-gray-400 font-normal text-sm">({{ 'words.optional' | translate | lowercase }})</span></h2>
                        <span class="text-xs text-gray-400">{{ profileEdit.biography?.length || 0 }} / 280</span>
                    </div>
                    <textarea [(ngModel)]="profileEdit.biography" [disabled]="!editEnabled" maxlength="280" rows="4"
                        [placeholder]="'account.profile.biography-placeholder' | translate"
                        class="flex w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100 resize-y"></textarea>
                    <p class="account-field__hint">
                        <i class="icon icon-student"></i>
                        {{ 'account.profile.appears-on-academic-profile' | translate }}
                    </p>
                </div>

                <!-- Guardar / cancelar (dentro de Editar perfil) -->
                <div class="account-profile__cta my-6" *ngIf="editEnabled">
                    <msc-button (click)="cancel()">
                        {{ 'words.cancel' | translate }}
                    </msc-button>

                    <msc-button class="msc-button--primary" palette="primary" (click)="save()">
                        {{ 'ai-admin.settings.save' | translate }}
                    </msc-button>
                </div>
            </div>

            <!-- ===== Cambiar contraseña card (último) ===== -->
            <div class="account-card" *ngIf="canChangePassword">
                <div class="account-card__title text-gray-700">
                    <span class="account-card__bar bg-gray-700"></span>
                    <h2 class="text-base font-semibold">{{ 'words.update-password' | translate }}</h2>
                </div>

                <div class="account-profile__fields">
                    <!-- Contraseña actual -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.old-password' | translate }}</p>
                        <div class="relative">
                            <input [type]="showPassword.old ? 'text' : 'password'" [(ngModel)]="credentials.old_password"
                                (ngModelChange)="passwordUpdated = false; passwordError.credential = false"
                                [readonly]="oldPassReadonly" (focus)="oldPassReadonly = false"
                                autocomplete="new-password" name="current-pass-check" role="presentation" placeholder="********"
                                [ngClass]="{ 'border-red-400 focus:ring-red-400': passwordError.credential }"
                                class="flex h-9 w-full rounded-md border border-gray-300 pl-3 pr-9 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                            <button type="button" tabindex="-1" *ngIf="credentials.old_password"
                                (click)="showPassword.old = !showPassword.old"
                                class="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600">
                                <i class="icon" [ngClass]="showPassword.old ? 'icon-eye-off' : 'icon-eye'"></i>
                            </button>
                        </div>
                        <p *ngIf="passwordError.credential" class="mt-1 text-sm font-medium text-red-600">
                            {{ 'error.password.credential' | translate }}
                        </p>
                    </div>

                    <!-- Nueva contraseña -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.new-password' | translate }}</p>
                        <div class="relative">
                            <input [type]="showPassword.new ? 'text' : 'password'" [(ngModel)]="credentials.password" (ngModelChange)="checkPasswordMatch()"
                                [disabled]="!credentials.old_password"
                                [placeholder]="'account.profile.placeholder.new-password' | translate"
                                class="flex h-9 w-full rounded-md border border-gray-300 pl-3 pr-9 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                            <button type="button" tabindex="-1" (click)="showPassword.new = !showPassword.new"
                                class="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600">
                                <i class="icon" [ngClass]="showPassword.new ? 'icon-eye-off' : 'icon-eye'"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Confirmar nueva contraseña -->
                    <div class="account-field">
                        <p class="mb-2 block text-gray-700 text-sm font-semibold">{{ 'words.confirm-new-password' | translate }}</p>
                        <div class="relative">
                            <input [type]="showPassword.confirm ? 'text' : 'password'" [(ngModel)]="credentials.password_confirmation" (ngModelChange)="checkPasswordMatch()"
                                [disabled]="!credentials.old_password"
                                [placeholder]="'account.profile.placeholder.confirm-password' | translate"
                                class="flex h-9 w-full rounded-md border border-gray-300 pl-3 pr-9 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-secondary disabled:cursor-not-allowed disabled:bg-gray-100">
                            <button type="button" tabindex="-1" (click)="showPassword.confirm = !showPassword.confirm"
                                class="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600">
                                <i class="icon" [ngClass]="showPassword.confirm ? 'icon-eye-off' : 'icon-eye'"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Reglas de validación -->
                <div class="mt-4 space-y-1">
                    <p class="color--grey text-error" [ngClass]="{'active': passwordError.short, 'valid': passwordValid.short }">
                        <i *ngIf="passwordError.short" class="icon icon-close"></i>
                        <i *ngIf="passwordValid.short" class="icon icon-checkmark-1"></i>
                        {{ "error.password.too-short" | translate }}
                    </p>
                    <p class="color--grey text-error" [ngClass]="{ 'active': passwordError.number, 'valid': passwordValid.number }">
                        <i *ngIf="passwordError.number" class="icon icon-close"></i>
                        <i *ngIf="passwordValid.number" class="icon icon-checkmark-1"></i>
                        {{ "error.password.number" | translate }}
                    </p>
                    <p class="color--grey text-error" [ngClass]="{ 'active': passwordError.uppercase, 'valid': passwordValid.uppercase }">
                        <i *ngIf="passwordError.uppercase" class="icon icon-close"></i>
                        <i *ngIf="passwordValid.uppercase" class="icon icon-checkmark-1"></i>
                        {{ "error.password.uppercase" | translate }}
                    </p>
                    <p class="color--grey text-error" [ngClass]="{ 'active': passwordError.lowercase, 'valid': passwordValid.lowercase }">
                        <i *ngIf="passwordError.lowercase" class="icon icon-close"></i>
                        <i *ngIf="passwordValid.lowercase" class="icon icon-checkmark-1"></i>
                        {{ "error.password.lowercase" | translate }}
                    </p>
                    <p class="color--red text-error" *ngIf="passwordError.confirm && credentials.password_confirmation.length > 0">{{ "error.password.no-match" | translate }}</p>
                    <p class="color--red text-error" *ngIf="credentials.password === credentials.old_password && credentials.password.length > 0">{{ "error.password.same" | translate }}</p>
                </div>

                <!-- Aviso de éxito -->
                <p *ngIf="passwordUpdated" class="mt-3 flex items-center gap-1.5 text-sm font-medium text-green-600">
                    <i class="icon icon-checkmark-1"></i>
                    {{ 'toast.password-updated' | translate }}
                </p>

                <div class="account-profile__cta">
                    <msc-button class="msc-button--primary" palette="primary" (click)="savePassword()"
                        [disabled]="credentials.old_password === '' || credentials.password === '' || credentials.password !== credentials.password_confirmation || passwordError.number || passwordError.lowercase || passwordError.uppercase">
                        {{ 'words.update-password' | translate }}
                    </msc-button>
                </div>
            </div>
        </section>
    </div>

    <div class="footer-privacy animate flex align-center">
        <small *ngIf="me.id === profile.id" class="mr-2">{{ 'profile.info' | translate }}</small>
        <a class="link-privacy" (click)="privacyPolicy()">
            {{ 'words.privacy-policy' | translate }}
        </a>
    </div>
</div>

<msc-common-modal size="30vw" #modalConfirmation [title]="'words.confirm-action' | translate">
    <ng-template>
        <p>{{ 'profile.modal.sso-integration-warning' | translate }}</p>
        <div class="flex items-center mt-5 space-x-5 justify-end">
            <msc-button class="" palette="primary" (click)="modalConfirmation.onClose()">{{'common.cancel' | translate}}
            </msc-button>
            <msc-button class="msc-button--primary" palette="primary" (click)="save(true); modalConfirmation.onClose()">
                {{'common.save' | translate}}</msc-button>
        </div>
    </ng-template>
</msc-common-modal>
